module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-it.942ddddf43958cd47711.svg";